// Mobile PDP carousel: re-show Plyr controls after a slide change.
// Only runs on pages that have the product media carousel, and gives up after ~10s
// (previously polled every 300ms forever on every page).
(function () {
  var SELECTOR = '.product__media-container.below-mobile.carousel';
  if (!document.querySelector(SELECTOR) && document.readyState !== 'loading') return;

  setTimeout(function () {
    if (!document.querySelector(SELECTOR)) return;
    var tries = 0;
    var waitForSwiper = setInterval(function () {
      tries++;
      var el = document.querySelector(SELECTOR);
      if (el && el.swiper) {
        clearInterval(waitForSwiper);
        el.swiper.on('slideChangeTransitionEnd', function () {
          document.querySelectorAll('.plyr__control').forEach(function (btn) {
            btn.classList.add('show-btn');
          });
        });
        document.addEventListener('click', function (e) {
          if (e.target.classList && e.target.classList.contains('plyr__control')) {
            e.target.classList.remove('show-btn');
          }
        });
        document.querySelectorAll('.plyr__control').forEach(function (btn) {
          btn.classList.add('show-btn');
        });
      } else if (tries >= 30) {
        clearInterval(waitForSwiper);
      }
    }, 300);
  }, 1500);
})();


// PDP Desc Read more Logic
document.addEventListener("DOMContentLoaded", function () {
  const mql = window.matchMedia("(max-width: 767px)");

  function setupMobileToggle() {
    if (mql.matches) {
      const readMore = document.getElementById("read-more");
      const readLess = document.getElementById("read-less");
      const truncated = document.getElementById("truncated-description");
      const fullMobile = document.getElementById("full-description-mobile");

      if (readMore && fullMobile) {
        readMore.onclick = () => {
          truncated.style.display = "none";
          fullMobile.style.display = "block";
        };
        readLess.onclick = () => {
          fullMobile.style.display = "none";
          truncated.style.display = "block";
        };
      }
    }
  }

  function setupDesktopToggle() {
    if (!mql.matches) {
      const readMoreDesktop = document.getElementById("read-more-desktop");
      const readLessDesktop = document.getElementById("read-less-desktop");
      const truncatedDesktop = document.getElementById("truncated-description-desktop");
      const fullDesktop = document.getElementById("full-description-desktop");

      if (readMoreDesktop && fullDesktop) {
        readMoreDesktop.onclick = () => {
          truncatedDesktop.style.display = "none";
          fullDesktop.style.display = "block";
        };
        readLessDesktop.onclick = () => {
          fullDesktop.style.display = "none";
          truncatedDesktop.style.display = "block";
        };
      }
    }
  }

  setupMobileToggle();
  setupDesktopToggle();

  mql.addEventListener("change", () => {
    setupMobileToggle();
    setupDesktopToggle();
  });
});


// Mobile collection: theme-styled sort dropdown (not OS-native).
// - Click toggle: open/close the dropdown
// - Click an option: update ?sort_by= and reload (preserves filters, drops page)
// - Click outside / Escape: close
(function () {
  var openDropdown = null;

  function setOpen(wrapper, open) {
    if (!wrapper) return;
    var toggle = wrapper.querySelector('[data-mobile-sort-toggle]');
    var list = wrapper.querySelector('[data-mobile-sort-list]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (list) list.setAttribute('aria-hidden', open ? 'false' : 'true');
    openDropdown = open ? wrapper : null;
  }

  function closeAll() {
    document.querySelectorAll('[data-mobile-sort-dropdown]').forEach(function (w) {
      setOpen(w, false);
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-mobile-sort-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrapper = toggle.closest('[data-mobile-sort-dropdown]');
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (!isOpen) setOpen(wrapper, true);
      return;
    }

    var option = e.target.closest && e.target.closest('[data-mobile-sort-option]');
    if (option) {
      e.preventDefault();
      var value = option.getAttribute('data-sort-value');
      try {
        var url = new URL(window.location.href);
        if (value) {
          url.searchParams.set('sort_by', value);
        } else {
          url.searchParams.delete('sort_by');
        }
        url.searchParams.delete('page');
        window.location.href = url.toString();
      } catch (err) {
        window.location.search = 'sort_by=' + encodeURIComponent(value);
      }
      return;
    }

    // Click outside any open dropdown closes it
    if (openDropdown && !e.target.closest('[data-mobile-sort-dropdown]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDropdown) closeAll();
  });
})();


// Product videos: autoplay (muted, looping) while on screen, pause when scrolled/swiped away.
// The theme (theme.min.js) adds the Plyr play/pause controls; we no longer create a second
// Plyr player here, which could double-wrap the video and stop it playing on desktop.
(function () {
  var videos = document.querySelectorAll('video[data-autoplay-in-view]');
  if (!videos.length) return;

  function tryPlay(v) {
    if (v.dataset.userPaused === 'true') return;
    v.muted = true;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  videos.forEach(function (v) {
    v.muted = true;
    v.playsInline = true;
    // If the shopper pauses it themselves, don't keep restarting it.
    v.addEventListener('pause', function () {
      if (v.dataset.autoPausing === 'true') { v.dataset.autoPausing = 'false'; return; }
      if (!v.ended) v.dataset.userPaused = 'true';
    });
    v.addEventListener('play', function () { v.dataset.userPaused = 'false'; });
  });

  if (!('IntersectionObserver' in window)) {
    videos.forEach(tryPlay);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        tryPlay(v);
      } else if (!v.paused) {
        v.dataset.autoPausing = 'true';
        v.pause();
      }
    });
  }, { threshold: 0.5 });

  videos.forEach(function (v) { io.observe(v); });
})();
